/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {ScheduleItem} from "./ScheduleItem";


export class GeneralEntryItem extends ScheduleItem {

  private static ICONS: {} = {
    2: 'md-sunny',
    3: 'md-restaurant',
    4: 'md-timer',
    5: 'md-timer',
    6: 'md-trophy',
    7: 'md-information-circle'
  };

  public icon: string;

  constructor(public id: string,
              public timestamp: number,
              public routineType: number,
              public entryStatus: number,
              public date: string,
              public timeSlot: string,
              public duration: number,
              public sequence: number,
              public title: string,
              public description: string,
              public fixedType: number) {

    super(id, timestamp, routineType, entryStatus, date, timeSlot, duration, sequence, title, description, fixedType);

    if (!entryStatus) {
      this.entryStatus = ScheduleItem.ENTRY_STATUS_CONFIRMED;
    }

    this.icon = GeneralEntryItem.ICONS[routineType];
  }

  static fromJson(key: string, json: any) {
    return GeneralEntryItem.fromSnapshot(key, json);
  }

  static fromSnapshot(key: string, {date, description, duration, entryStatus, routineType, sequence, fixedType, timeSlot, timestamp, title}) {
    return new GeneralEntryItem(key, timestamp, routineType, entryStatus, date, timeSlot, duration, sequence, title, description, fixedType);
  }

}



// WEBPACK FOOTER //
// ./src/models/schedule/GeneralEntryItem.ts